import { ReactNode } from "react";
import { View } from "./View";

export interface ICardProps {
  className?: string;
  children: ReactNode;
}

export const Card = (props: ICardProps) => {
  return <View {...props} />;
};
